<micro-select-combo #sel
              placeholder="Bind Count Scope"
              [mode]="mode"
              [(id)]="bindCountScope"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched"
>
</micro-select-combo>
